module.exports = __webpack_public_path__ + "img/sale-bannar2.c2988b2e.png";